import { Small } from 'palette/Typography';

import '../styles/Attributes.scss';

interface AttributesProps {
    attributes?: string[];
    numberOfAttributes?: number;
}

function Attributes({
    attributes = [],
    numberOfAttributes = 2,
}: AttributesProps) {
    return (attributes.length > 0 ? (
        <ul className="palette-product-card-attributes">
            {
                attributes.slice(0, numberOfAttributes).map(attribute => (
                    <li
                        key={attribute}
                        className="palette-product-card-attributes__attribute"
                    >
                        <Small
                            className="palette-product-card-attributes__text"
                            color="light"
                            level="1"
                            tagName="h5"
                        >
                            {attribute}
                        </Small>
                    </li>
                ))
            }
        </ul>
    ) : null);
}

export default Attributes;
